/**
 * Browser-side HTTP calls the login screen makes. Extracted from
 * app/(auth)/login/page.tsx (OPL-4289) — the URL, method, headers, credentials
 * mode and body here are identical to what the page sent before.
 */

/**
 * Cloud-backup status for the freshly signed-in user. The raw Response is
 * returned because the caller branches on the status code alone: a 401 means
 * the user has a Better Auth session but no sigma profile row yet.
 */
export function fetchLoginBackupStatus(): Promise<Response> {
	return fetch("/api/backup/status", {
		method: "GET",
		headers: { "Content-Type": "application/json" },
	});
}
